import { useTranslation } from 'react-i18next';

const adv03Img = '/images/advantages-innovation-engine.png';

const adv04Img = 'http://geel.fp.08wx.cn/images/956b0239095c3109bc707cb492f37edc.jpg';

export default function AdvDetailsSection02() {
  const { t } = useTranslation();
  const innovations = [
    { icon: 'ri-lock-2-line', title: t('advantages.s2.inno.0.t'), desc: t('advantages.s2.inno.0.d') },
    { icon: 'ri-stack-overflow-line', title: t('advantages.s2.inno.1.t'), desc: t('advantages.s2.inno.1.d') },
    { icon: 'ri-robot-line', title: t('advantages.s2.inno.2.t'), desc: t('advantages.s2.inno.2.d') },
    { icon: 'ri-nft-line', title: t('advantages.s2.inno.3.t'), desc: t('advantages.s2.inno.3.d') },
  ];
  const complianceItems = [
    { region: t('advantages.s2.comp.0.r'), body: 'MAS', desc: t('advantages.s2.comp.0.d') },
    { region: t('advantages.s2.comp.1.r'), body: 'SFC', desc: t('advantages.s2.comp.1.d') },
    { region: t('advantages.s2.comp.2.r'), body: 'MiCA', desc: t('advantages.s2.comp.2.d') },
    { region: t('advantages.s2.comp.3.r'), body: 'FinCEN', desc: t('advantages.s2.comp.3.d') },
    { region: t('advantages.s2.comp.4.r'), body: 'CIMA', desc: t('advantages.s2.comp.4.d') },
    { region: t('advantages.s2.comp.5.r'), body: 'FSC', desc: t('advantages.s2.comp.5.d') },
  ];

  return (
    <section className="bg-pink-50/50 py-8 space-y-0 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-white via-transparent to-white pointer-events-none" />

      {/* ADV 03: Innovation */}
      <div className="relative max-w-[1400px] mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 xl:gap-20 items-start">
          <div>
            <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
              <span className="text-primary text-xs font-mono font-bold">03</span>
              <span className="text-primary text-xs font-medium uppercase tracking-wider">{t('advantages.s2.tag1')}</span>
            </div>

            <h2 className="text-4xl font-heading font-bold text-gray-900 mb-6 leading-tight">
              {t('advantages.s2.title1')}
              <br />
              <span className="text-primary">{t('advantages.s2.title1h')}</span>
            </h2>

            <p className="text-gray-500 text-base leading-relaxed mb-8">
              {t('advantages.s2.desc1')}
              {t('advantages.s2.desc2')}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {innovations.map((item, i) => (
                <div
                  key={i}
                  className="bg-white border border-primary/15 rounded-xl p-5 hover:border-primary/35 transition-colors group"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-primary/10 border border-primary/20 rounded-lg mb-3 group-hover:bg-primary/20 transition-colors">
                    <i className={`${item.icon} text-primary text-lg`} />
                  </div>
                  <h4 className="text-gray-900 font-semibold text-sm mb-2">{item.title}</h4>
                  <p className="text-gray-500 text-xs leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden border border-primary/15">
            <div className="w-full h-[520px]">
              <img src={adv03Img} alt="Innovation" className="w-full h-full object-cover object-top" />
              <div className="absolute inset-0 bg-gradient-to-t from-white/60 via-transparent to-transparent" />
            </div>
            <div className="absolute bottom-5 left-5 right-5 bg-white/95 border border-primary/20 rounded-xl px-5 py-4 backdrop-blur-sm">
              <div className="text-gray-800 text-sm font-medium mb-2">{t('advantages.s2.rd')}</div>
              <div className="flex items-center gap-6">
                <div>
                  <div className="text-primary text-xl font-heading font-black">30%+</div>
                  <div className="text-gray-500 text-xs">{t('advantages.s2.rd1')}</div>
                </div>
                <div>
                  <div className="text-primary text-xl font-heading font-black">15+</div>
                  <div className="text-gray-500 text-xs">{t('advantages.s2.rd2')}</div>
                </div>
                <div>
                  <div className="text-primary text-xl font-heading font-black">50+</div>
                  <div className="text-gray-500 text-xs">{t('advantages.s2.rd3')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="h-px bg-gradient-to-r from-transparent via-primary/15 to-transparent" />
      </div>

      {/* ADV 04: Security & Compliance */}
      <div className="relative max-w-[1400px] mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 xl:gap-20 items-start">
          <div className="relative rounded-2xl overflow-hidden border border-primary/15">
            <div className="w-full h-[460px]">
              <img src={adv04Img} alt="Security Compliance" className="w-full h-full object-cover object-top" />
              <div className="absolute inset-0 bg-gradient-to-t from-white/60 via-transparent to-transparent" />
            </div>
            <div className="absolute top-5 left-5 bg-white/95 border border-primary/25 rounded-xl px-4 py-3 backdrop-blur-sm">
              <div className="flex items-center gap-2 mb-1">
                <i className="ri-shield-star-line text-primary text-sm" />
                <span className="text-gray-800 text-xs font-medium">{t('advantages.s2.badge')}</span>
              </div>
              <div className="text-gray-500 text-xs">{t('advantages.s2.badged')}</div>
            </div>
          </div>

          <div>
            <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
              <span className="text-primary text-xs font-mono font-bold">04</span>
              <span className="text-primary text-xs font-medium uppercase tracking-wider">{t('advantages.s2.tag2')}</span>
            </div>

            <h2 className="text-4xl font-heading font-bold text-gray-900 mb-6 leading-tight">
              {t('advantages.s2.title2')}
              <br />
              <span className="text-primary">{t('advantages.s2.title2h')}</span>
            </h2>

            <p className="text-gray-500 text-base leading-relaxed mb-8">
              {t('advantages.s2.desc3')}
              {t('advantages.s2.desc4')}
            </p>

            <h4 className="text-sm font-semibold text-gray-700 mb-4">{t('advantages.s2.compTitle')}</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {complianceItems.map((item, i) => (
                <div key={i} className="bg-white border border-primary/15 rounded-xl p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs font-bold text-primary">{item.region}</span>
                    <span className="px-2 py-0.5 bg-primary/10 border border-primary/20 text-primary text-xs rounded font-mono">
                      {item.body}
                    </span>
                  </div>
                  <p className="text-gray-500 text-xs leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
